import { ChameleonMatchType } from '@/@types/generated'
import { register } from './enum'

export const ChameleonMatchTypeTextColor: Record<ChameleonMatchType, string> = {
  [ChameleonMatchType.USDOT]: 'text-red-900',
  [ChameleonMatchType.CARRIER_NAME]: 'text-blue-900',
  [ChameleonMatchType.DBA_NAME]: 'text-blue-900',
  [ChameleonMatchType.PHONE]: 'text-green-900',
  [ChameleonMatchType.EMAIL]: 'text-purple-900',
  [ChameleonMatchType.SSN]: 'text-orange-900',
  [ChameleonMatchType.EIN]: 'text-teal-900',
  [ChameleonMatchType.ADDRESS]: 'text-amber-900',
  [ChameleonMatchType.OWNER_NAME]: 'text-pink-900',
}

export const ChameleonMatchTypeBackgroundColor: Record<
  ChameleonMatchType,
  string
> = {
  [ChameleonMatchType.USDOT]: 'bg-red-100',
  [ChameleonMatchType.CARRIER_NAME]: 'bg-blue-100',
  [ChameleonMatchType.DBA_NAME]: 'bg-blue-100',
  [ChameleonMatchType.PHONE]: 'bg-green-100',
  [ChameleonMatchType.EMAIL]: 'bg-purple-100',
  [ChameleonMatchType.SSN]: 'bg-orange-100',
  [ChameleonMatchType.EIN]: 'bg-teal-100',
  [ChameleonMatchType.ADDRESS]: 'bg-amber-100',
  [ChameleonMatchType.OWNER_NAME]: 'bg-pink-100',
}

export const ChameleonMatchTypeLabels: Record<ChameleonMatchType, string> = {
  [ChameleonMatchType.USDOT]: 'USDOT',
  [ChameleonMatchType.CARRIER_NAME]: 'Carrier Name',
  [ChameleonMatchType.DBA_NAME]: 'DBA Name',
  [ChameleonMatchType.PHONE]: 'Phone',
  [ChameleonMatchType.EMAIL]: 'Email',
  [ChameleonMatchType.SSN]: 'SSN',
  [ChameleonMatchType.EIN]: 'EIN',
  [ChameleonMatchType.ADDRESS]: 'Address',
  [ChameleonMatchType.OWNER_NAME]: 'Owner Name',
}

register<ChameleonMatchType>(ChameleonMatchType, (v) => {
  if (!v) return '\u2014'
  return ChameleonMatchTypeLabels[v]
})
